import { useDeviceInfo } from '@cian/ui-kit/responsive';
import { useToast } from '@cian/ui-kit/toast';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { NotFoundToastAction, NotFoundToastContent } from 'shared/map-search/components/NotFoundToast';
import { selectJsonQuery } from 'shared/map-search/selectors/results';

import { NOT_FOUND_TOAST_TEST_ID } from './constants';
import { useIsPortrait } from './hooks';
import { getToastIndent } from './utils';

interface INotFoundToastContainerProps {
  onChangeFiltersClick(): void;
}

export const NotFoundToastContainer: React.FC<INotFoundToastContainerProps> = ({ onChangeFiltersClick }) => {
  const { isPhone, isTablet } = useDeviceInfo();
  const isPortrait = useIsPortrait();
  const toast = useToast({
    placement: 'bottom-center',
    size: 'L',
    indent: getToastIndent({ isPhone, isTablet, isPortrait }),
  });
  const jsonQuery = useSelector(selectJsonQuery);
  // Контент тоста фиксируется в момент открытия, поэтому актуальный обработчик берём из рефа
  const onChangeFiltersClickRef = React.useRef(onChangeFiltersClick);

  React.useEffect(() => {
    onChangeFiltersClickRef.current = onChangeFiltersClick;
  }, [onChangeFiltersClick]);

  // Переоткрываем тост на каждый новый поиск: после применения фильтров область может остаться пустой
  React.useEffect(() => {
    const id = toast.open({
      type: 'info',
      dataTestId: NOT_FOUND_TOAST_TEST_ID,
      autoHide: false,
      hasCloseIcon: false,
      content: <NotFoundToastContent />,
      rightAdornment: ({ id: toastId }) => (
        <NotFoundToastAction
          onClick={() => {
            // Тосты рисуются поверх модалок, поэтому убираем тост, чтобы он не перекрывал модалку фильтров
            toast.hide(toastId);
            onChangeFiltersClickRef.current();
          }}
        />
      ),
    });

    return () => toast.hide(id);
  }, [toast, jsonQuery]);

  return null;
};
